import { MemberRow } from '../models/unit.model';
import { AgendaMonth, createAgendaMonths, isPastAgendaDay } from '@shared/components/agenda/agenda.model';

export interface BirthdayMember extends MemberRow {
  birthdayAge: number;
}

export type BirthdayMonth = AgendaMonth<BirthdayMember>;

export function groupBirthdays(members: MemberRow[], today: Date): BirthdayMonth[] {
  const eligible = members.filter(member => member.birthDate &&
    !Number.isNaN(member.birthDate.getTime()) && member.status !== 'Departed');
  return createAgendaMonths<BirthdayMember>(today).map(agendaMonth => {
    const { month, year, isCurrent } = agendaMonth;
    const byDay = new Map<number, MemberRow[]>();
    for (const member of eligible) {
      if (member.birthDate!.getMonth() !== month || member.birthDate!.getFullYear() > year) continue;
      const day = member.birthDate!.getDate();
      byDay.set(day, [...(byDay.get(day) ?? []), member]);
    }
    return {
      ...agendaMonth,
      days: [...byDay.entries()].sort(([a], [b]) => a - b).map(([day, people]) => {
        const date = new Date(year, month, day);
        const exists = date.getMonth() === month;
        return {
          day,
          weekday: exists ? new Intl.DateTimeFormat('es-AR', { weekday: 'short' }).format(date).replace('.', '') : '',
          isToday: isCurrent && day === today.getDate(),
          isPast: isPastAgendaDay(year, month, day, today),
          items: people.map(member => ({ ...member, birthdayAge: year - member.birthDate!.getFullYear() }))
            .sort((a, b) => `${a.firstName} ${a.lastName}`.localeCompare(`${b.firstName} ${b.lastName}`, 'es')),
        };
      }),
    };
  }).filter(month => month.isCurrent || month.days.length > 0);
}
